import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, ButtonGroup, Tabs, Tab } from '@mui/material';
import { PageHeader } from 'components/molecules/PageHeader/PageHeader';
import TabPanel from 'components/atoms/TabPanel/TabPanel';
import UsersPage from './UsersPage';
import OrdersPage from './OrdersPage';
import BrokerAccountsPage from './BrokerAccountsPage';
import { Navigate } from 'react-router-dom';
import { routes } from 'routes';

/**
 * AdminPanel Component
 * Main component for the admin panel with navigation tabs
 */
export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState(0);
  const profile = useSelector(state => state.userProfile.data);

  // Redirect if not an admin
  if (!profile || profile.user_type !== 'ADMIN') {
    return <Navigate to={routes.home} />;
  }

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <PageHeader text1="Admin" text2="Panel" description="Administration and Monitoring" />
      
      <Box sx={{ mb: 4, mt:2 }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Users" />
          <Tab label="Broker Accounts" />
          <Tab label="Orders" />
        </Tabs>
      </Box>

      <TabPanel value={activeTab} index={0}>
        <UsersPage />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <BrokerAccountsPage />
      </TabPanel>

      <TabPanel value={activeTab} index={2}>
        <OrdersPage />
      </TabPanel>
    </>
  );
} 